const Contacts = [
    {
        id: 1,
        name: "Pavani Priya",
        phone: 8919047022,
        image:"images/pavani.jpg",
        email: "pavanipriya6124@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/pavani-priya-516b66248",
        instagramLink: "https://www.instagram.com/pavanipriya6124?igsh=NzZsOHc3eHc5bXM0"
    },
    {
        id: 2,
        name: "Deekshitha Sontam",
        phone: 6303344985,
        image:"images/deekshitha.jpg",
        email: "deekshithasontam555@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/deekshitha-sontam-755a21263",
        instagramLink: "https://www.instagram.com/deekshitha_sontam"
    },
    {
        id: 3,
        name: "Lakshyta Mahajan",
        phone: 9977730008,
        image:"images/lakshyta.jpg",
        email: "lakshytamahajan.1502@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/lakshyta-mahajan-9a919b259",
        instagramLink: "jhjbfnv"
    },
    {
        id: 4,
        name: "Mohd Nasar Siddiqui",
        phone: 7880734529,
        image:"images/nasar.jpg",
        email: "nasarsidd986@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/mohd-nasar-a2284a25a",
        instagramLink: "https://www.instagram.com/mns__nasar?igsh=dXQxeGd6MXhoanRu"
    },
    {
        id: 5,
        name: "Nilesh Maneshwar",
        phone: 8305100535,
        image:"images/nilesh.jpg",
        email: "nileshmaneshwar449@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/nilesh-maneshwar-64b0a8257",
        instagramLink: "https://www.instagram.com/niles_h_7"
    },
    {
        id: 6,
        name: "Atharv Moghe",
        phone: 6232133073,
        image:"images/atharv.jpg",
        email: "mogheatharv07@gmail.com",
        linkedInLink: "http://linkedin.com/in/atharv-moghe-5a5bb0268",
        instagramLink: "http://www.instagram.com/atharv_moghe07?igsh=MXcwNTBseGgxMTJ2dg%3D%3D&utm_source=qr"
    },
    {
        id: 7,
        name: "Jaswanth",
        phone: 7013451713,
        image:"images/jaswanth.jpg",
        email: "sanapala.jaswanth1@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/jaswanth-sanapala-0b8b69257",
        instagramLink: "https://www.instagram.com/mr.jaswanth_11?igsh=MTNjYWpqMWMxNTBzbQ=="
    },
    {
        id: 8,
        name: "Prabhat Kumar Yadav",
        phone: 7267911138,
        image:"images/prabhat.jpeg",
        email: "prabhatyadav10240@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/prabhat-kumar-yadav-a1307a259",
        instagramLink: "https://www.instagram.com/prabhat_kumar_iitk/#"
    },
    {
        id: 9,
        name: "Kuldeep Thakre",
        phone: 9067032879,
        image:"images/kuldeep.jpg",
        email: "thakarekuldeep2004@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/kuldeep-thakare-123450250",
        instagramLink: "https://www.instagram.com/thakare_cooldeep/"
    },  
    {
        id: 10,
        name: "Kartik",
        phone: 9569443372,
        image:"images/kartik.jpg",
        email: "kartikkartik29957@gmail.com",
        linkedInLink: "http://www.linkedin.com/in/kartik-kumar-01a600258",
        instagramLink: "jhjbfnv"
    },

]

export default Contacts;